import React, { lazy } from 'react';
import { RouteConfig } from 'react-router-config';
import IconLaunch from '@/assets/images/menu/icon-launch.react.svg?react';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';

export const launchRoutes = (): RouteConfig[] => [
  {
    path: '/launch',
    name: '启动',
    icon: <MenuIcon icon={IconLaunch} />,
    sort: 92,
    platforms: [
      CapitalPlatform.Android,
      CapitalPlatform.IOS,
      CapitalPlatform.Mac,
      CapitalPlatform.VisionOS,
      CapitalPlatform.Flutter,
    ],
    routes: [
      {
        path: '/launch/analytics',
        name: '指标分析',
        component: lazy(() => import('@/presentation/pages/launch/analytics')),
      },
      {
        path: '/launch/issues',
        name: '启动个例',
        component: lazy(() => import('@/presentation/pages/launch/issues')),
      },
    ],
  },
];

export default launchRoutes;
